// extracted by mini-css-extract-plugin
export default {"successTop":"success_successTop__PqArE","successHeader":"success_successHeader__-YBye","successText":"success_successText__0uWh9","successBottom":"success_successBottom__WPSW5"};